import { Component, Injector, Input, OnInit } from '@angular/core';
import { WorkplaceActionHandlerBase } from '../../../../../components/common/grid-base/actions/workplace-action-handler-base';
import { WorkplaceAreaHostBase } from '../../../../../components/common/workplace-area-host-base/workplace-area-host-base';
import { WorkplaceBase } from '../../../../../components/common/workplace-base/workplace-base';

/**
 * Comparables workspace
 */
@Component({
  selector: 'comparables-workplace',
  templateUrl: './comparables-workplace.component.html',
  styleUrls: ['./comparables-workplace.component.scss']
})
export class ComparablesWorkplaceComponent extends WorkplaceBase implements OnInit {
  /**
   * The host component
   */
  private _main: WorkplaceAreaHostBase;

  /**
   * Sets the host component
   */
  @Input() public set main(value: WorkplaceAreaHostBase) {
    this._main = value;
  }

  /**
  * Gets the host component
  */
  public get main(): WorkplaceAreaHostBase {
    return this._main;
  }

  /**
   * The tab config
   */
  public get tabConfig() {
    return [
      {
        "id": "tabProperty",
        "searchMode": "comparablesProperty",
        "tabIndex": 0,
        "tabHierarchy": 0,
        "isLeafHierarchy": false,
        "enableSearch": true,
        "exportAreaName": "Objects"
      },
      {
        "id": "tabValuation",
        "searchMode": "comparablesValuation",
        "tabIndex": 1,
        "tabHierarchy": 1,
        "isLeafHierarchy": true,
        "enableSearch": true,
        "exportAreaName": "Valuation"
      },
      {
        "id": "tabLeases",
        "searchMode": "comparablesLease",
        "tabIndex": 2,
        "tabHierarchy": 2,
        "isLeafHierarchy": true,
        "enableSearch": true,
        "exportAreaName": "Lease"
      }
    ];
  }

  /**
   * Constructor
   * @param injector Injector
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.selectedTab = '#tabProperty'
    this.init();
  }

  /**
   * Gets the action handlers used by this workspace area. Implement all logic in these handlers, NOT in the derived class of this class.
   */
  protected get actionHandlers(): WorkplaceActionHandlerBase[] {
    return [
    ];
  }

  /**
   * Register the events
   */
  protected registerEvents(): void {
    this.onEvents.push(this.eventBus.subscribeEvent('comparablesTabSelect', (item)=> {
      this.selectedTab = "#" + item;
      const tab = this.tabConfig.find((it) => { return it.id == item; });

      this.main.setSelectedImportArea(tab.exportAreaName || '');

      this.eventBus.broadcastEvent("toolbarSetArea", tab.searchMode);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('buttonExport', () => {
      this.doExport();
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('buttonTogglePVInfoModeComp', () => {
      const currentVisibility = this.main.infoBarVisibility;
      this.main.setInfoBarVisibility(!currentVisibility, false, false, null);
    }));


    this.onEvents.push(this.eventBus.subscribeEvent('buttonDeleteComp', () => {
      this.eventBus.broadcastEvent('delete' + this.main.selectedImportArea);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('buttontemplateComp', () => {
      this.main.createTemplate();
    }));
  }

  /**
   * Search clicked
   * @param tab
   */
  public onSearchClicked(tab): void {
    super.onSearchClicked(tab);
    this.eventBus.broadcastEvent("resetComparablesSearchMode");
    this.eventBus.broadcastEvent("toolbarSetArea", tab.searchMode);
  }

  /**
   * Sets the counter value
   * @param tab
   * @param value
   */
  public setCounterValue(tab, value): void {
    super.setCounterValue(tab, value);
  }
}
